import { Skeleton } from '@backstage/ui';
import { DrawerHeader } from './DrawerHeader';
import chatStyles from '../Chat/Chat.module.css';

/** Shaped like the loaded chat so the drawer does not jump when it lands. */
export const ChatSkeleton = () => (
  <div className={chatStyles.chat}>
    <DrawerHeader />
    <div className={chatStyles.messages}>
      <div className={chatStyles.thread}>
        <Skeleton
          className={chatStyles.skeletonLine}
          style={{ width: '40%' }}
        />
        <Skeleton
          className={chatStyles.skeletonLine}
          style={{ width: '70%' }}
        />
        <Skeleton
          className={chatStyles.skeletonLine}
          style={{ width: '55%' }}
        />
      </div>
    </div>
    <div className={chatStyles.composerDock}>
      <Skeleton className={chatStyles.skeletonComposer} />
    </div>
  </div>
);
